import React from "react";

/*
 * Badges per DESIGN.md §4: 12px text, 4px 12px padding, radius 12.
 * primary: Royal Blue / 700 · secondary: Light Gray / 600 · error: red tint / 600
 * navy: Navy / 700 (category type chip) · onNavy: white-10 on navy surfaces
 * size="sm" — the 11px row chip from the category-page reference.
 */

const VARIANTS = {
  primary: "bg-ic-blue text-white font-bold",
  secondary: "bg-ic-lightGray text-ic-body font-semibold",
  error: "bg-[rgba(228,29,29,0.1)] text-ic-error font-semibold",
  navy: "bg-ic-navy text-ic-offwhite font-bold",
  onNavy: "bg-white/10 text-ic-lightGray font-bold",
};

const SIZES = {
  md: "text-[12px] leading-4 px-3 py-1",
  sm: "text-[11px] leading-4 px-2.5 py-0.5",
};

export default function Badge({ variant = "secondary", size = "md", className = "", children, ...rest }) {
  return (
    <span
      className={`inline-flex items-center tracking-[0.5px] rounded-xl whitespace-nowrap ${VARIANTS[variant] || VARIANTS.secondary} ${SIZES[size] || SIZES.md} ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}
